import { useEffect } from "react";

function PageNotFound() {
  useEffect(() => {
    const re = /^\/mdl/;
    if (re.test(window.location.pathname)) {
      window.location.replace("/mdl");
    } else {
      window.location.replace("/dv");
    }
  }, []);

  return null;
}

export default PageNotFound;
